module.exports = __webpack_public_path__ + "img/qr_code.0b72492c.png";